import { render } from "./PartnerResultPage.vue?vue&type=template&id=3b211b62&scoped=true"
import script from "./PartnerResultPage.vue?vue&type=script&lang=js"
export * from "./PartnerResultPage.vue?vue&type=script&lang=js"

import "./PartnerResultPage.vue?vue&type=style&index=0&id=3b211b62&scoped=true&lang=css"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b211b62"]])

export default __exports__